export enum MutationKeys {
  acceptTermsAndConditions,
}
